import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import KeyIcon from "@mui/icons-material/Key";

// import NewspaperIcon from '@mui/icons-material/Newspaper';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LogoutIcon from "@mui/icons-material/Logout";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import GradingIcon from "@mui/icons-material/Grading";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DownloadIcon from "@mui/icons-material/Download";

import { deleteUserWS } from "../api/settingsApi";
import { gestioneSnackbar } from "../../../utils/common";
// import { useNavigate } from 'react-router-dom';

let deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

export const settingsMenu = [
  [
    {
      id: 1,
      value: "settings.menu.privacy_policy",
      icon: PrivacyTipIcon,
      arrow: true,
      path: "/privacy-policy",
    },
    {
      id: 2,
      value: "settings.menu.term_of_use",
      icon: GradingIcon,
      arrow: true,
      path: "/term-of-use",
    },
    {
      id: 3,
      value: "settings.menu.password",
      icon: KeyIcon,
      arrow: true,
      path: "/change-password",
    },
  ],
  [
    {
      id: 4,
      value: "settings.menu.whatsapp_channel",
      icon: WhatsAppIcon,
      arrow: true,
      function: () => {
        window.open(
          "https://whatsapp.com/channel/0029Vb5OU5jA89Mh9wvIEm0o ",
          "_blank"
        );
      },
    },
    {
      id: 5,
      value: "settings.menu.donwload_app",
      icon: DownloadIcon,
      arrow: false,
      function: async (e) => {
        e?.preventDefault?.(); // Evita crash se e è undefined/null
        console.log(deferredPrompt);
        if (deferredPrompt) {
          deferredPrompt.prompt(); // Mostra il popup di installazione
          const { outcome } = await deferredPrompt.userChoice;
          console.log("Scelta utente:", outcome);
          deferredPrompt = null; // Pulisce la variabile dopo l’uso
        } else {
          alert(
            "Installazione non disponibile automaticamente.\n\nPer installare l'app da CHROME, clicca sull'icona del menu del browser (⋮ o ☐) e seleziona 'Aggiungi a schermata Home' oppure 'Installa app'.\n\nPer installare l'app da SAFARI, tocca l'icona di condivisione (il quadrato con la freccia in alto) e poi scegli 'Aggiungi a schermata Home'."
          );
        }
      },
    },
    {
      id: 6,
      banner_notification: true,
      icon: NotificationsActiveIcon,
      value: "settings.menu.push_notification",
    },
  ],
  [
    {
      id: 7,
      value: "settings.menu.create_association",
      icon: AddCircleOutlineOutlinedIcon,
      arrow: false,
      path: "/create-association",
    },
    {
      id: 8,
      value: "settings.menu.calendar",
      icon: CalendarMonthIcon,
      arrow: false,
      path: "/calendar",
    },
    {
      id: 10,
      value: "settings.menu.logout",
      icon: LogoutIcon,
      arrow: false,
      function: () => {
        localStorage.clear();
        window.location.replace("/login");
      },
    },
    {
      id: 11,
      value: "settings.menu.delete_account",
      icon: WarningAmberIcon,
      arrow: false,
      red: true,
      customDialog: true,
      function: () => {
        deleteUserWS()
          .then((res) => {
            gestioneSnackbar(true, res.message, "success");
            localStorage.clear();
            window.location.replace("/login");
          })
          .catch((err) => gestioneSnackbar(true, err, "error"));
      },
    },
  ],
];
